import { openwebActions } from '../actionTypes';
import Moment from 'moment';
import createLogger from '../../utils/createLogger';
import {_insertRecord} from "../utils";

const DEBUG = true;
const debug = createLogger(DEBUG, `openwebReducer.js`);

/* -------- initial state -------- */
const initialState = {openweb_cache: [], can_start_run: true};

export default (state = initialState, action) => {
  switch (action.type) {
    /* ----- get openweb list ----- */
    case openwebActions.GET_OPENWEBS_REQUEST:
      return state;

    case openwebActions.GET_OPENWEBS_FAILURE:
      return state;

    case openwebActions.GET_OPENWEBS_SUCCESS:
      if (action.data) {
        let can_start = true;
        console.log(action.data);
        if (action.data.active > 3) {
          can_start = false;
        }
        let cache = action.data.results;
        for (let s of cache) {
          s.start = Moment(s.start).format('YYYY-MM-DDTHH:mm:ss');
          if (s._updated !== null) {
            s._updated = Moment(s._updated).format('YYYY-MM-DDTHH:mm:ss');
          }
          if (s.finished !== null){
            s.finished = Moment(s.finished).format('YYYY-MM-DDTHH:mm:ss');
          }
        }
        return {...state, can_start_run: can_start, openweb_cache: cache};
      }
      return state;

    /* ----- get openweb details ----- */
    case openwebActions.GET_OPENWEB_REQUEST:
      return state;

    case openwebActions.GET_OPENWEB_FAILURE:
      return state;

    case openwebActions.GET_OPENWEB_SUCCESS:
      if (action.data) {
        let new_cache = [...state.openweb_cache];
        for (let i in new_cache){
          if (new_cache[i]["_id"] === action.data["_id"]){
            new_cache.splice(i, 1, action.data);
          }
        }
        return {...state, openweb_cache: new_cache}
      }
      return state;

    case openwebActions.POST_OPENWEBS_REQUEST:
      return state;

    case openwebActions.POST_OPENWEBS_FAILURE:
      return state;

    case openwebActions.POST_OPENWEBS_SUCCESS:
      if (action.data) {
        let new_cache = [...state.openweb_cache];
        new_cache.unshift(action.data);
        return {...state, openweb_cache: new_cache}
      }
      return state;

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/data/openweb/openwebReducer.js